if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // iOS safe init timing
      requestAnimationFrame(() => this.setup());
    }

    setup() {
      this.promotion = this.querySelector('.promotion');
      if (!this.promotion) return;

      // 🔧 iPhone fix — don't hard stop on reduced motion
      if (window.FoxTheme && FoxTheme.config.motionReduced) {
        console.log('Motion reduced — still allowing promotion scroll');
      }

      this.initObserver();
    }

    initObserver() {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.init();
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        {
          rootMargin: '0px',
          threshold: 0.1
        }
      );

      io.observe(this);
    }

    init() {
      if (this._inited) return;
      this._inited = true;

      this.promotion.classList.add('promotion--animated');

      // 🔧 mobile performance safe clone count
      const cloneCount = window.innerWidth < 768 ? 4 : 8;

      for (let i = 0; i < cloneCount; i++) {
        const clone = this.promotion.cloneNode(true);
        this.appendChild(clone);
      }
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }

  customElements.define('scrolling-promotion', ScrollingPromotion);
}
